export default __webpack_public_path__ + "static/media/Esmax-40-Cap-ban.c435e794.jpg";